import { getDefaultHeaderHeight as _getDefaultHeaderHeight } from "@react-navigation/elements";
import { Platform } from "react-native";
import { useSafeAreaFrame, useSafeAreaInsets } from "react-native-safe-area-context";
export var getDefaultHeaderHeight = function(layout, modalPresentation, statusBarHeight) {
    var defaultHeight = _getDefaultHeaderHeight(layout, modalPresentation, statusBarHeight);
    if (Platform.OS === 'ios' && !Platform.isPad && !modalPresentation) {
        // we want to accomodate our normal size Button in headers on portrait and landscape on iOS
        return Math.max(50 + statusBarHeight, defaultHeight);
    }
    return defaultHeight;
};
export function useDefaultHeaderHeight() {
    var dimensions = useSafeAreaFrame();
    var insets = useSafeAreaInsets();
    return getDefaultHeaderHeight(dimensions, false, insets.top);
}
